import { occupancyLevel } from "./capacity.js";
import { normalizeOccupancyDigest } from "./merge.js";
import { projectCoachCalendar } from "./projection.js";
import { OccupancyDigestSchema, } from "./schemas.js";
import { canonicalJson } from "./utils.js";
/**
 * Il digest lo compone solo chi possiede tutte le pianificazioni. Contiene
 * conteggi e capienze, mai nomi: l'atleta deve poter decidere se spostarsi, non
 * sapere chi c'e'.
 */
export function buildOccupancyDigest(input) {
    const generatedAt = input.now ?? new Date().toISOString();
    const entries = projectCoachCalendar(input.gym, input.schedules, input.fromDate, Math.max(1, input.days)).flatMap((day) => day.slots.map((slot) => ({
        occurrenceKey: slot.key,
        date: day.date,
        slotId: slot.occurrence.slotId,
        count: slot.participants.length,
        capacity: slot.capacity,
        updatedAt: generatedAt,
        updatedBy: input.generatedBy,
    })));
    return normalizeOccupancyDigest(OccupancyDigestSchema.parse({
        schemaVersion: 1,
        gymId: input.gym.id,
        entries,
        generatedAt,
        generatedBy: input.generatedBy,
    }));
}
/**
 * I soli numeri, senza chi li ha calcolati e quando: e' cio' che permette di
 * decidere se vale la pena pubblicare. Confrontare il digest intero farebbe
 * partire una pubblicazione a ogni ricalcolo, perche' l'istante cambia sempre.
 */
export function occupancyFingerprint(digest) {
    return canonicalJson(digest.entries.map((entry) => [entry.occurrenceKey, entry.count, entry.capacity]));
}
export function readOccupancy(digest, occurrenceKey) {
    const entry = digest?.entries.find((candidate) => candidate.occurrenceKey === occurrenceKey);
    if (!entry)
        return undefined;
    return {
        count: entry.count,
        capacity: entry.capacity,
        level: occupancyLevel(entry.count, entry.capacity),
    };
}
/**
 * La giornata come somma dei suoi intervalli: e' il livello che serve a chi sta
 * decidendo *quando* venire, prima ancora di scegliere l'ora.
 */
export function readDayOccupancy(digest, date) {
    const entries = digest?.entries.filter((candidate) => candidate.date === date) ?? [];
    if (entries.length === 0)
        return undefined;
    const count = entries.reduce((total, entry) => total + entry.count, 0);
    const capacity = entries.reduce((total, entry) => total + entry.capacity, 0);
    return { count, capacity, level: occupancyLevel(count, capacity) };
}
